import { Component, OnInit } from '@angular/core';
import { WebappService } from './shared/services/webapp.service';
import { AppService } from './shared/services/app.service';

@Component({
  selector: 'mobo-root',
  templateUrl: './app.component.html',
  styles: [],
})
export class AppComponent implements OnInit {
  title = 'mobo-web';

  constructor(
    private webappService: WebappService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.watchCity();
    this.watchRestaurants();
    this.getEvents();
    this.getFeatures();
  }

  watchCity() {
    this.webappService.selectedCity.subscribe((cityId) => {
      this.webappService.getCampains(cityId);
      this.webappService.getRestaurantByCity(cityId);
    });
  }

  watchRestaurants() {
    this.webappService.restaurants.subscribe((restaurants) => {
      const cityId = this.webappService.selectedCity.value;
      this.webappService.createSlugs(cityId, restaurants);
    });
  }

  getEvents() {
    this.webappService.getEvents();
  }

  getFeatures() {
    if (this.webappService.isBrowser) {
      let features = sessionStorage.getItem('features');
      this.appService.features = features ? JSON.parse(features) : {};
    }
  }
}
